// eslint-disable-next-line consistent-default-export-name/default-import-match-filename
import withFormProviders from './withFormProviders'

export default withFormProviders
